<app-loader *ngIf="loader"></app-loader>
<section>
  <app-navbar></app-navbar>

  <div class="container-fluid">
    <h4 class="text-light mt-4 mb-0">What‘s my bill <br />looking like?</h4>
    <div class="row d-flex justify-content-end">
      <span class="selected_meter font-weight-bold">
        Device : {{ selected_meter_id }}
      </span>
      <!-- <span class="font-weight-bold selected_meter">Device 01 </span> -->
    </div>
    <div class="row mt-3">
      <div class="col-sm-12 col-xs-12 col-md-12">
        <span class="tip"></span>
        <div class="card main_card">
          <div class="card-body">
            <div class="mb-3 d-flex justify-content-between">
              <button
                class="btn"
                [ngClass]="{ active: clicked === true }"
                data-toggle="tab"
                (click)="clicked = true; clicked1 = false; clicked2 = false"
                (click)="getLast24Hours()"
              >
                Day
              </button>
              <button
                class="btn"
                [ngClass]="{ active: clicked1 === true }"
                data-toggle="tab"
                (click)="clicked = false; clicked1 = true; clicked2 = false"
                (click)="getLast7days()"
              >
                Week
              </button>
              <button
                class="btn"
                [ngClass]="{ active: clicked2 === true }"
                data-toggle="tab"
                (click)="clicked = false; clicked1 = false; clicked2 = true"
                (click)="getLast12months()"
              >
                Month
              </button>
              <button class="btn" disabled>Year</button>
            </div>

            <p class="uptime text-danger" *ngIf="uptimePercentage">
              <span>Live: &nbsp;</span>{{ uptimePercentage.toFixed(1) }}%
            </p>
            <canvas
              id="myChart"
              style="
                background: #ffffff;
                border: 1px solid #9b9b9b;
                border-radius: 10px;
                padding: 5px;
              "
            ></canvas>
            <div class="row mt-4 pl-3 mb-5 energy_statement">
              <div class="col-6 background_color mb-5">
                <h6 class="text-danger mt-2">Energy <br />Statement</h6>
                <div class="statement d-flex align-items-center mt-3">
                  <img
                    src="../../../assets/img/statement.svg"
                    alt="statement"
                    class="img-fluid"
                  />
                  <p class="ml-3 mb-0">Your latest energy Statement.</p>
                </div>
                <button
                  class="btn d-block ml-auto mr-auto mt-2 mb-3 view_btn"
                  data-toggle="modal"
                  data-target="#exampleModal"
                >
                  View
                </button>
              </div>
              <div class="col-6 mb-5">
                <p class="text_color font-weight-bold">
                  Est. bill this month
                  <img
                    src="../../../assets/img/Question_mark.svg"
                    alt=""
                    style="height: 25px; margin-bottom: 5px; cursor: pointer;"
                    data-toggle="modal" data-target="#question"
                  />
                </p>
                <h4 class="text-danger">Rs.----</h4>
                <!-- <a href=""><img src="../../../assets/img/pay_button.svg" alt="pay" class="img-fluid w-100"></a> -->
                <a
                  href="https://paytm.com/electricity-bill-payment"
                  target="_blank"
                >
                  <button class="pay d-flex">
                    <img
                      src="../../../assets/img/pay.svg"
                      alt="pay"
                      class="img-fluid"
                    /><span class="text-center ml-md-3">Pay energy bill</span>
                  </button></a
                >
                <button class="usage mt-2 d-flex" routerLink="/analysis">
                  <img
                    src="../../../assets/img/usage.svg"
                    alt="usage"
                    class="img-fluid"
                  />Analyse usage
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<app-bottom-navbar></app-bottom-navbar>

<!-- Modal -->
<div
  class="modal fade"
  id="exampleModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="exampleModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header border-bottom-0">
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form
          #form_statement="ngForm"
          class="form_statement"
          id="form_statement"
          name="form_statement"
        >
          <div class="input-group mb-3">
            <input
              type="text"
              class="form-control"
              placeholder="Enter Email id "
              type="text"
              [(ngModel)]="email"
              name="email"
              required
            />
          </div>
          <div class="form-group mb-3">
            <input
              type="text"
              onfocus="(this.type='date')"
              class="form-control"
              placeholder="From Date"
              [(ngModel)]="fromDate"
              id="fromData"
              name="fromDate"
              max="{{ today || today }}"
              required
            />
          </div>
          <div class="form-group mb-3">
            <input
              type="text"
              onfocus="(this.type='date')"
              placeholder="Upto Date"
              class="form-control"
              [(ngModel)]="toDate"
              name="toDate"
              id="toDate"
              min="{{
                form_statement.value.fromDate || !form_statement.value.fromDate
              }}"
              required
            />
          </div>
          <!-- <div id="recaptcha-container" class="g-recaptcha"></div> -->
          <div class="form-group">
            <div
              id="recaptcha-container"
              class="g-recaptcha"
              data-callback="verifyRecaptchaCallback"
              data-expired-callback="expiredRecaptchaCallback"
            ></div>
            <input
              class="form-control d-none"
              data-recaptcha="true"
              required
              data-error="Please complete the Captcha"
            />
            <div class="help-block with-errors"></div>
          </div>

          <div class="opt_btn">
            <button
              type="button"
              class="btn btn-danger w-50 d-block m-auto"
              (click)="getStatement()"
            >
              GET STATEMENT
            </button>
          </div>

          <!-- <p class="already_para text-dark d-flex justify-content-center align-item-center mt-3">Already registered?&nbsp;
                        <a class="font-weight-bold">Sign in</a></p> -->
        </form>
      </div>
    </div>
  </div>
</div>


<!-- Modal -->
<div class="modal fade" id="question" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content " style="width: 50%; margin: auto;">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" style="padding-top: 0; padding: 10px;">
       <h6 class="font-weight-bold text-danger">
        Kindly fill the utility details in Mybots section for getting bill forecast
       </h6>
      </div>
    </div>
  </div>
</div>